<template>
  <form v-if="!icono" enctype="multipart/form-data" novalidate>
    <v-avatar v-if="avatar" size="128">
      <img v-if="!loading" id="imgSel" :src="imgTemp" alt="Imagen no disponible" @click="openFilesSelector()">
    </v-avatar>
    <v-file-input v-show="!avatar" ref="fileInput" v-model="files" :accept="accept" color="success accent-4" :label="labelText" :loading="loading"
                  placeholder="" :disabled="isSaving" prepend-inner-icon="mdi-paperclip" prepend-icon="" @change="filesChange()"
    >
      <template v-slot:selection="{ index, text }">
        <v-chip v-if="index < 2" color="gold accent-4" dark label small>
          {{ text }}
        </v-chip>
        <span v-else-if="index === 2" class="overline grey--text text--darken-3 mx-2">
          +{{ selectedFile.length - 2 }} archivo(s)
        </span>
      </template>
      <template v-slot:append-outer>
        <v-icon :disabled="notAFile" @click="downloadContract">
          mdi-download-box
        </v-icon>
      </template>
    </v-file-input>
  </form>
  <div v-else>
    <v-tooltip content-class="top" top>
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs" v-on="on" :disabled="notAFile" @click="downloadContract">
          mdi-download-box
        </v-icon>
      </template>
      <span>{{ nombreDocumento }}</span>
    </v-tooltip>
  </div>
</template>
<script>
  const STATUS_INITIAL = 0
  const STATUS_SAVING = 1
  const STATUS_SUCCESS = 2
  const STATUS_FAILED = 3

  export default {
    name: 'UploadFiles',

    props: {
      documentoId: {
        type: Number,
        required: false,
        default: 0,
      },
      tipo: {
        type: String,
        required: false,
        default: '*.*',
      },
      // carpeta destino donde se almacena el archivo
      folder: {
        type: String,
        required: false,
        default: '/',
      },
      labelText: {
        type: String,
        required: false,
        default: 'Documentación',
      },
      // para laravel, si se utiliza el disk local o public
      public: {
        type: Boolean,
        required: false,
        default: false,
      },
      // para archivos img
      avatar: {
        type: Boolean,
        required: false,
        default: false,
      },
      icono: {
        type: Boolean,
        required: false,
        default: false,
      },
      maxSize: {
        type: Number,
        required: false,
        default: 10,
      },
      resetear: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data () {
      return {
        dataFile: null,
        cargado: false,
        files: [],
        selectedFile: null,
        extension: '',
        uploadPercentage: 0,
        uploadError: null,
        currentStatus: null,
        baseurl: this.$store.state.UrlBase,
        imgTemp: null,
        loading: false,
      }
    },
    computed: {
      nombreDocumento () {
        return (this.dataFile !== null) ? this.dataFile.registro.nombre : ''
      },
      accept: function () {
        switch (this.tipo) {
          case 'pdf':
            return '.pdf'
          case 'imagen':
            return 'image/*'
          default:
            return '*.*'
        }
      },
      notAFile: function () {
        return (this.documentoId === null || this.documentoId === 0)
      },
      isSaving () {
        return this.currentStatus === STATUS_SAVING
      },
    },
    watch: {
      documentoId () {
        if (!this.cargado) {
          this.cargarArchivo()
        }
      },
      dataFile (val) {
        if (this.avatar) {
          this.cargarImagen()
        }
      },
      resetear () {
        this.reset()
      },
    },
    mounted () {
      this.reset()
      this.cargarArchivo()
    },
    created () {
      this.imgTemp = this.baseurl + 'Imagen_no_disponible.png'
    },
    methods: {
      cargarImagen () {
        if (this.public) {
          this.imgTemp = this.baseurl + this.dataFile.registro.path
        } else {
          this.$http.get('/api/image/?path=' + this.dataFile.registro.path, { responseType: 'arraybuffer' })
            .then(response => {
              var newBlob = new Blob([response.data], { type: 'image/*' })
              this.readFile(newBlob, function (e) {
                document.getElementById('imgSel').src = e.target.result
              })
            })
        }
      },
      cargarArchivo () {
        if (this.documentoId !== null && this.documentoId !== 0) {
          this.$store.dispatch('axiosMod/getData', { url: '/api/files/data/' + this.documentoId }).then(response => {
            this.dataFile = response
            this.cargado = true
            if (this.selectedFile === null) {
              this.crearEmptyFile(response.registro.nombre)
            }
          })
        }
      },
      crearEmptyFile (nombre) {
        var file = new File([], nombre)
        this.files.push(file)
      },
      readFile (newBlob, onLoadCallback) {
        var reader = new FileReader()
        reader.onload = onLoadCallback
        reader.readAsDataURL(newBlob)
      },
      downloadContract () {
        this.$http.get('/api/files/download/' + this.documentoId + '/disk/' + this.public, { responseType: 'arraybuffer' })
          .then(response => {
            this.downloadFile(response, 'documentacion')
          }, response => {
            // console.warn('error from download_contract')
            // console.log(response)
          },
          )
      },
      downloadFile (response, filename) {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        var newBlob = new Blob([response.data], { type: this.dataFile.mimetype })
        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob

        var url = URL.createObjectURL(newBlob)
        var a = document.createElement('a')
        a.href = url
        a.target = '_blank'
        a.click()

        /* if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob)
          return
        }

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob)
        var link = document.createElement('a')
        link.href = data
        link.download = filename + '.pdf'
        link.click()
        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data)
        }, 100) */
      },
      openFilesSelector () {
        this.$refs.fileInput.$refs.input.click()
      },
      reset () {
        // reset form to initial state
        this.currentStatus = STATUS_INITIAL
        this.selectedFile = null
        this.uploadError = null
        this.files = []
      },
      save (formData) {
        // upload data to the server
        this.currentStatus = STATUS_SAVING
        const url = '/api/files/upload'
        const setting = {
          headers: {
            Authorization: 'Bearer ' + this.$store.state.token,
            'content-type': 'multipart/form-data',
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total))
          }.bind(this),
        }
        this.$http.post(url, formData, setting)
          .then(response => {
            this.currentStatus = STATUS_SUCCESS
            this.dataFile = response.data
            this.loading = false
            this.$emit('documento', response.data.registro.id)
            this.$emit('subiendo', false)
          }).catch(error => {
            this.currentStatus = STATUS_FAILED
            this.uploadError = error.response.data.errors
          })
      },
      filesChange () {
        if (this.files !== undefined) {
          this.selectedFile = this.files
          this.loading = true
          const fileName = this.selectedFile.name
          // const FileSize = this.selectedFile.size / 1024  // in KB
          // const FileType= this.selectedFile.type
          this.extension = (fileName.substring(fileName.lastIndexOf('.') + 1)).toLowerCase()
          // validacion de los archivos aca ...
          if (this.selectedFile.size <= (1048576 * this.maxSize)) {
            const formData = new FormData()
            formData.append('public', this.public)
            formData.append('path', this.folder)
            formData.append('file', this.selectedFile)

            // save it
            this.$emit('subiendo', true)
            this.save(formData)
          } else {
            this.selectedFile = null
            this.loading = false
            this.files = []
            this.$store.commit('toast/show', { tipo: 'error', messages: ['El archivo seleccionado supera el tamaño máximo permitido'] })
          }
        }
      },
    },
  }
  /*
TOP_LEFT = "top-left",
    TOP_CENTER = "top-center",
    TOP_RIGHT = "top-right",
    BOTTOM_LEFT = "bottom-left",
    BOTTOM_CENTER = "bottom-center",
    BOTTOM_RIGHT = "bottom-right"
*/
</script>
